import Vue from 'vue'
import VuetifyEasyCrud from '@tmigone/vuetify-easy-crud'
// import VuetifyEasyCrud from '../../../vuetify-easy-crud/dist/vuetify-easy-crud.common.js'

Vue.use(VuetifyEasyCrud)
